import get from 'lodash/get';
import { actionsEnum } from 'pages/store/actions/defaults';

const filterInitialState = {};

const filter = (state = filterInitialState, action) => {
  const { filterId, filter: actionFilter, type } = action;

  switch (type) {
    case actionsEnum.FILTER_SET: {
      return {
        ...state,
        [filterId]: {
          ...get(state, filterId, {}),
          [actionFilter.filterCategory]: {
            ...get(state, `${filterId}.${actionFilter.filterCategory}`, {}),
            [actionFilter.filterName]: actionFilter.isSet,
          },
        },
      };
    }

    case actionsEnum.FILTER_SET_CATEGORY:
      return {
        ...state,
        [filterId]: {
          ...get(state, filterId, {}),
          [actionFilter.filterCategory]: {
            ...get(state, `${filterId}.${actionFilter.filterCategory}`, {}),
            ...actionFilter.filterState,
          },
        },
      };

    case actionsEnum.DATA_CLEAR:
      return filterInitialState;

    case actionsEnum.FILTER_CLEAR:
      return {
        ...state,
        [filterId]: {},
      };

    default:
      return state;
  }
};

export default filter;
